import { Columns } from '#types/grid';

export const columnDefinition: Columns = [
  {
    key: 'customer.customer_lookup_dialog.grid.columns.custid',
    field: 'custid',
    width: 120,
    sort: 'asc',
    sortOrder: 1,
  },
  {
    key: 'customer.customer_lookup_dialog.grid.columns.name',
    field: 'name',
    width: 220,
  },
  {
    key: 'customer.customer_lookup_dialog.grid.columns.phone',
    field: 'phone',
    width: 110,
  },
  {
    key: 'customer.customer_lookup_dialog.grid.columns.contact',
    field: 'contact',
    width: 120,
  },
  {
    key: 'customer.customer_lookup_dialog.grid.columns.credithold',
    field: 'credithold',
    width: 70,
    formatter: 'yn',
  },
  {
    key: 'customer.customer_lookup_dialog.grid.columns.statusabbrev',
    field: 'statusabbrev',
    width: 80,
  },

  // end of default columns

  {
    key: 'customer.customer_lookup_dialog.grid.columns.status',
    field: 'status',
    width: 100,
    visible: false,
    canToggleVisibility: false,
  },
  {
    key: 'customer.customer_lookup_dialog.grid.columns.lookup',
    field: 'lookup',
    width: 200,
    visible: false,
  },
];
